import { makeStyles } from '../../../styles';
export default makeStyles((theme) => ({
    '@global': {
        '.handsontable': {
            /* Right-click context menu */
            '&.htContextMenu': {
                backgroundColor: theme.colors.primary.contrastWhite,
                borderRadius: theme.spacing(1),
                boxShadow: theme.shadows[1],
                padding: theme.spacing(1),
                border: `0.5px solid ${theme.colors.gray[200]}`,
                /* Override height manually calculated and applied by handsontable inline */
                '& .wtHolder, & .wtHider': {
                    height: 'auto !important',
                },
                /* Clear basic library-provides styles we don't need */
                '& table.htCore': {
                    border: 0,
                    '& .htItemWrapper': {
                        margin: 0,
                        width: '100%',
                    },
                },
                /* Custom dropdown options (i.e. with icon) */
                '& .ht_master table td.htCustomMenuRenderer': {
                    padding: 0,
                    height: 'auto !important',
                },
            },
            '& .htAutocompleteArrow': {
                fontSize: '15px',
                width: '25px',
            },
        },
    },
    spreadsheet: {
        width: 'calc(100% - 32px)',
        minHeight: 'calc(100vh - 165px)',
        overflow: 'hidden',
        '& .handsontable': {
            color: theme.colors.text[900],
            fontFamily: 'Source Sans Pro, sans-serif',
            /* Default cell styles */
            '& td': {
                '&:not(.htSelect)': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },
                '& > div': {
                    display: 'inline',
                },
            },
            /* Rounded corners */
            '& thead tr': {
                '& th:first-of-type': {
                    borderTopLeftRadius: theme.spacing(1),
                },
                '& th:last-of-type': {
                    borderTopRightRadius: theme.spacing(1),
                },
            },
            '& tbody tr:last-of-type': {
                '& td:last-of-type': {
                    borderBottomRightRadius: theme.spacing(1),
                },
                '& th': {
                    borderBottomLeftRadius: theme.spacing(1),
                },
            },
            /* Content grid color */
            '& td, & th': {
                borderColor: `${theme.colors.gray[200]} !important`,
                padding: theme.spacing(0, 1),
                /* Selection area */
                '&.area:before': {
                    backgroundColor: theme.colors.primary.main,
                    opacity: 0.05,
                },
            },
            /* Heading cells style overrides (column and rows) */
            '& tbody th, & thead th': {
                backgroundColor: `${theme.colors.gray[100]} !important`,
                verticalAlign: 'middle',
                textTransform: 'uppercase',
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: 0.3,
                color: theme.colors.gray[800],
                borderColor: `${theme.colors.gray[200]} !important`,
                '&.ht__active_highlight': {
                    color: theme.colors.primary.contrastWhite,
                    backgroundColor: `${theme.colors.primary.main} !important`,
                },
            },
            /* Invalid state */
            '& td[aria-invalid="true"]': {
                border: `1px solid ${theme.colors.error.main} !important`,
                backgroundColor: 'inherit !important',
                position: 'relative',
                '&:before': {
                    content: 'attr(aria-errormessage)',
                    color: theme.colors.error.main,
                    position: 'absolute',
                    top: '0',
                },
            },
            '& td.htInvalid': {
                backgroundColor: `${theme.colors.primary.contrastWhite} !important`,
            },
            /* Disabled */
            '& td.htDimmed': {
                color: theme.colors.text[600],
                backgroundColor: theme.colors.gray.neutral,
            },
            '& td.listbox.htDimmed': {
                color: theme.colors.text[600],
                backgroundColor: '#fff',
                borderColor: `${theme.colors.gray[200]} !important`,
                borderRadius: `0 !important`,
                '&:hover': {
                    backgroundColor: theme.colors.gray[0],
                },
                '&.current': {
                    backgroundColor: theme.colors.gray[0],
                },
            },
            /* Select */
            '& td.htSelect': {
                position: 'relative',
                '& > div:not(.htAutocompleteArrow)': {
                    marginTop: 6,
                    display: 'inline-block',
                    width: `calc(100% - 30px)`,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },
                '& .select-expand-icon': {
                    position: 'absolute',
                    padding: theme.spacing(1),
                    top: 0,
                    right: 0,
                    width: 'auto',
                    height: 'auto',
                },
            },
            /* Inputs */
            '& .handsontableInput': {
                color: theme.colors.text[900],
            },
        },
    },
}));
//# sourceMappingURL=Spreadsheet.styles.js.map